import { testimonials, siteInfo } from '@/mocks/chigua';
import { SectionHead } from './HotDeep';

export function About() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <SectionHead
        eyebrow="About Us"
        title="为什么大家愿意在这儿吃瓜"
        desc="我们不替谁站队，只把散落的线索摆到同一张桌上，让结论自己浮现。"
      />

      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
        <div className="rounded-xl border border-background-200 bg-background-100 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <span className="grid h-12 w-12 place-items-center rounded-lg bg-primary-500 font-heading text-xl font-black text-background-50">
              瓜
            </span>
            <div>
              <h3 className="font-heading text-xl font-black text-foreground-950">{siteInfo.name}</h3>
              <p className="text-xs text-foreground-500">{siteInfo.tagline}</p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">{siteInfo.intro}</p>

          <div className="mt-6 grid grid-cols-3 gap-3 text-center">
            {[
              { k: '证据优先', v: '多信源印证' },
              { k: '逐帧还原', v: '按时间码对齐' },
              { k: '不站队', v: '以官方回应为准' },
            ].map((x) => (
              <div key={x.k} className="rounded-lg bg-background-50 px-2 py-4">
                <p className="font-heading text-sm font-bold text-primary-600">{x.k}</p>
                <p className="mt-1 text-xs text-foreground-500">{x.v}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4">
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-1 text-secondary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < t.rating ? 'ri-star-fill' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="grid h-10 w-10 place-items-center rounded-full bg-accent-100 font-heading font-bold text-accent-700">
                  {t.avatar}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}